export default __webpack_public_path__ + "static/0700-4b9b65b01354f958868fb32e4d9253b4.jpeg";